<template>
  <nuttrema-layout-form-standard :edit="edit">
    <el-form slot="center">
      <section>
        <h4 class="section-title">{{ $t('label.set_profile_picture') }}</h4>
        <el-upload
           action="action"
           class="avatar-uploader"
          :class="{ 'is-disabled': !edit }"
          :drag="true"
          :httpRequest="onUploadProfilePicture"
          :disabled="!edit"
          :show-file-list="false"
          :before-upload="beforeUploadProfilePicture"
          :on-success="onUploadProfilePictureSuccess">
          <div class="hover-info" :class="{ 'is-show': !imageUrl }">
            <i class="el-icon-upload"></i>
            <p>{{ $t('label.drop_file_here') }}</p>
          </div>
          <img v-if="imageUrl" :src="imageUrl" class="avatar">
        </el-upload>
        <div class="section-help">
          <p>{{ $t('label.jpg_png_files', { value: '500kb' }) }}</p>
        </div>
      </section>
    </el-form>
    <template slot="footer">
      <div class="footer-row">
        <popover-question-alert
           buttonTitle="label.remove_profile_picture"
           buttonType="danger"
           popoverWidth="280"
           buttonSize="small"
          :popoverShouldShow="true"
          @confirmed="onRemoveProfilePicture">
        </popover-question-alert>
      </div>
    </template>
  </nuttrema-layout-form-standard>
</template>

<script>
import { get } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import PopoverQuestionAlert from 'components/ui/alert/nuttrema-popover-question-alert';

export default {
  name: 'form-my-prefferences-profile-picture',
  props: {
    personalProfile: {
      required: true,
      default: null,
    },
    edit: {
      type: Boolean,
      required: true,
      default: false,
    },
    saveError: {
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaLayoutFormStandard,
    PopoverQuestionAlert,
  },
  computed: {
    imageUrl() {
      const path = get(this.personalProfile, 'ProfilePicture.path', false);
      const filename = get(this.personalProfile, 'ProfilePicture.thumbnails.large.filename', false);
      return path && filename ? `${process.env.IMAGES_ROOT}${path}${filename}` : null;
    },
  },
  methods: {
    onCancelClick() {
      this.$emit('cancel');
    },
    onUploadProfilePicture(options) {
      this.$emit('uploadProfilePicture', options.file);
    },
    onRemoveProfilePicture() {
      this.$emit('removeProfilePicture');
    },
    onUploadProfilePictureSuccess() {
      this.$emit('uploadProfilePictureSuccess');
    },
    beforeUploadProfilePicture() {},
  },
};
</script>

<style lang="scss">
  @import '~assets/styles/theme/colors';

  .avatar-uploader {
    margin: 1em !important;
    text-align: left;

    .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      width: 240px;
      height: 240px;
      cursor: pointer;
      position: relative;
      overflow: hidden;

      &:hover {
        border-color: #20a0ff;
      }

      .hover-info {
        position: absolute;
        top: 0; left: 0;
        width: 100%; height: 100%;
        background: rgba(255,255,255,0.75);
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.25s linear;

        p, i { color: #8c939d; }

        &.is-show {
          opacity: 1;
          visibility: visible;
          background: rgba(#20a0ff, 0.05);
        }
      }

      .avatar-uploader-icon {
        font-size: 32px;
        color: #8c939d;
        width: 240px;
        height: 240px;
        line-height: 240px !important;
        text-align: center;
      }

      .avatar {
        width: 240px;
        height: 240px;
        display: block;
      }

      .el-upload-dragger {
        border: none;
        width: inherit;
        height: inherit;
        .el-icon-upload {
          margin: 5rem 0 1rem;
        }
        &:hover {
          .hover-info {
            opacity: 1;
            visibility: visible;
            background: rgba(0,0,0, 0.35);
            p, i { color: #fff; }
            &.is-show {
              background: rgba(#20a0ff, 0.05);
              p, i { color: #20a0ff; }
            }
          }
        }
      }
    }

    &.is-disabled {
      .el-upload .hover-info {
        p, i { color: $gray-light; }
        &.is-show {
          background: transparent;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/professional/settings/my-preferences/profile-picture/form-my-prefferences-profile-picture.vue